import api from '../../api'
import {orderItems} from '../../helpers'
import Vue from 'vue';

export default {
    state: {
        feeds: [],
        current: null,
        current_feed: null,
        picked_notice: null,
    },
    mutations:{
        ADD_FEED: (state, feed) => {
            state.feeds.push(feed)
        },
        DEL_FEED: (state, _id) => {
            state.feeds = state.feeds.filter( feed => feed._id != _id)
        },
        RENAME_FEED: (state, {_id, name}) => {
            for (const feed of state.feeds) {
                if(feed._id == _id){
                    feed.name = name
                    return true
                }
            }
        },
        UPD_FEED: (state, {_id, notices}) => {
            for (const feed of state.feeds) {
                if(feed._id == _id){
                    feed.notices = notices
                    return true
                }
            }
        },     
        EDIT_FEED: (state, {_id, text}) => {
            for (const feed of state.feeds) {
                if(feed._id == _id){
                    feed.body = text
                    return true
                }
            }
        }, 
        MOVE_NOTICE: (state, {feed_from_id, feed_to_id, notice_id, to_feeds}) => {
            for (const feed of state.feeds) {
                if (feed._id == feed_to_id) {
                    feed.notices = to_feeds
                }
                if(feed._id == feed_from_id) {
                    feed.notices.splice(feed.notices.findIndex(item => item._id == notice_id), 1) 
                }
            }
        },               
        EDIT_NOTICE: (state, {feed_id, notice_id, text}) => {
            for (const feed of state.feeds) {
                if(feed._id == feed_id){
                    for (const notice of feed.notices) {
                        if(notice._id == notice_id){
                            notice.body = text
                            return true
                        }
                    }
                }
            }
        },
        UPDATE_NOTICE: (state, { feed_id, notice_id, attr, value}) => {
            for (const feed of state.feeds) {
                if(feed._id == feed_id){
                    for (const notice of feed.notices) {
                        if(notice._id == notice_id){
                            notice[attr] = value
                            return true
                        }
                    }
                }
            }
        },        
        SET_COMPLETED_NOTICE: (state, {feed_id, notice_id, value}) => {
            for (const feed of state.feeds) {
                if(feed._id == feed_id){
                    for (const notice of feed.notices) {
                        if(notice._id == notice_id){
                            Vue.set(notice,'completedInFeed', value)
                            return true
                        }
                    }
                }
            }
        },
        TOGGLE_PICKED_NOTICE: (state, notice) => {
            if(state.picked_notice && state.picked_notice._id == notice._id) {
                state.picked_notice = null
            } else {
                state.picked_notice = notice
            }
        },
        SET_NOTICE_PUSHES: (state, {feed_id, notice_id, pushes}) => {
            for (const feed of state.feeds) {
                if(feed._id == feed_id){
                    for (const notice of feed.notices) {
                        if(notice._id == notice_id){
                            notice.pushes = pushes
                            return true
                        }
                    }
                }
            }
        },        
        EDIT_NOTICE_PUSH: (state, {feed_id, notice_id, push_id, data}) => {
            for (const feed of state.feeds) {
                if(feed._id == feed_id){
                    for (const notice of feed.notices) {
                        if(notice._id == notice_id){
                            for (const push of notice.pushes) {
                                if(push._id == push_id){
                                    push[data.key] = data.value
                                    return true
                                }
                            }
                        }
                    }
                }
            }
        },        
        PUT_FEEDS: (state, feeds) => {
            state.feeds = feeds
        },
        CLEAR_FEEDS: (state) => {
            state.feeds = []
        },                
        SET_CURRENT_FEED: (state, feed) => {
            state.current_feed = feed
        },   
        SET_CURRENT_FEED_BY_ROUTE: (state, {feed}) => {
            const feedFiltred = state.feeds.filter(el => el.route_name == feed)[0]
            if(!feedFiltred) 
                return false
            state.current_feed = feedFiltred
        },      
        CLEAR_CURRENT_FEED: (state) => {
            state.current_feed = null
        },                 
    },
    actions: {
        async addFeed({ commit }, feed) {
            try {
                const req = await api.post('/feeds', feed)
                commit('ADD_FEED', req.data.data)
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить ленту')
                throw e
            }
        },        
        async delFeed({ commit }, _id) {
            try {
                const req = await api.delete('/feeds/' + _id)
                commit('DEL_FEED', _id)
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось удалить ленту')
                throw e
            }            
        },        
        async renameFeed({ commit }, {_id, name}) {
            try {
                const req = await api.put('/feeds/' + _id, { attr: 'name', value: name })
                commit('RENAME_FEED', {_id, name})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось переименовать ленту')
                throw e
            } 
        },        
        async editFeed({ commit }, {_id, text}) {
            try {
                const req = await api.put(`/feeds/${_id}`, { attr: 'body', value: text })
                commit('EDIT_FEED', {_id, text})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось отредактировать ленту')
                throw e
            } 
        },  
        updateFeed({ commit }, {_id, feeds}) {
            // /feeds
            commit('UPD_FEED', {_id, feeds})
        },         
        async saveOrderFeeds({ commit }, feeds_id) {
            try {
                const req = await api.put('/user', {attr: 'feedsOrder', valueJson: JSON.stringify(feeds_id)})
                commit('SET_ORDER_FEEDS', feeds_id)
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось сохранить порядок лент')
                throw e
            }
        },       
        async getFeeds({ commit, state, getters, dispatch}, params) {
            try {
                let req
                req = await api.get('/feeds')
                req.data.data.forEach(feed => {
                    feed.notices.forEach(notice => {
                        notice.parent_name = feed.name
                        notice.parent_route = `/feeds/${feed.route_name}`
                    })
                })
                const feedDrags = orderItems(req.data.data, getters.orderFeeds)
                if (getters.orderFeeds.length) {
                    commit('PUT_FEEDS', feedDrags)
                } else {
                    commit('PUT_FEEDS', req.data.data)
                }
                if (params.feed) {
                    commit("SET_CURRENT_FEED_BY_ROUTE", params)
                }else{
                    state.feeds.length && commit('SET_CURRENT_FEED', state.feeds[0]) 
                }
                if(!getters.feeds.length) {
                    await dispatch('addFeed', {name: "Default", body: ""})
                }                                                
                return true;
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось получить ленты')
                throw e;
            }
        },      
        async addNotice({ commit }, {feed_id, notice}) {
            try {
                const req = await api.post(`/feeds/${feed_id}/notices`, notice)
                commit('UPD_FEED',{_id: feed_id, notices: req.data.data})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить заметку')
                throw e
            }
        },              
        async editNotice({ commit }, {feed_id, notice_id, text}) {
            try {
                const req = await api.put(`/feeds/${feed_id}/notices/${notice_id}`, { attr: 'body', value: text })
                commit('EDIT_NOTICE', {feed_id, notice_id, text})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось отредактироватьь заметку')
                throw e
            } 
        },
        async setImagesToNotice({ commit }, {feed_id, notice_id, images}) {
            try {
                const req = await api.put(`/feeds/${feed_id}/notices/${notice_id}`, { attr: 'images', valueJson: JSON.stringify(images) })
                commit('UPDATE_NOTICE', {feed_id, notice_id, attr: 'images', value: images})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить картинку для заметки')
                throw e
            } 
        },  
        async setBlockedLinksToNotice({ commit }, {feed_id, notice_id, blockedLinks}) {
            try {
                const req = await api.put(`/feeds/${feed_id}/notices/${notice_id}`, { attr: 'blockedLinks', valueJson: JSON.stringify(blockedLinks) })
                commit('UPDATE_NOTICE', {feed_id, notice_id, attr: 'blockedLinks', value: blockedLinks})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить картинку для заметки в черный список')
                throw e
            } 
        },  
        async setCompletedNotice({ commit }, {feed_id, notice_id, value}) {
            try {
                const req = await api.put(`/feeds/${feed_id}/notices/${notice_id}`, { attr: 'completedInFeed', value })
                commit('SET_COMPLETED_NOTICE', {feed_id, notice_id, value})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить заметку в архив')
                throw e
            } 
        }, 
        async toggleCompletedRelevantNotice({ commit, getters }, { current_task_id, notice}) {
            try {
                const parentNoticeFeed  = getters.feeds.find(feed => feed.name == notice.parent_name)
                const tasksId = notice.completedInTasks 
                if (tasksId.includes(current_task_id)) {
                    tasksId.splice(~tasksId.indexOf(current_task_id), 1)
                    const req = await api.put(`/feeds/${parentNoticeFeed._id}/notices/${notice._id}`, { attr: 'completedInTasks', valueJson: JSON.stringify(tasksId)})
                    commit('SET_COMPLETED_RELEVANT_NOTICE', {notice_id: notice._id, tasksId})
                } else {
                    tasksId.push(current_task_id)
                    const req = await api.put(`/feeds/${parentNoticeFeed._id}/notices/${notice._id}`, { attr: 'completedInTasks', valueJson: JSON.stringify(tasksId)})
                    commit('SET_COMPLETED_RELEVANT_NOTICE', {notice_id: notice._id, tasksId})
                }
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить релавантную заметку в архив')
                throw e
            } 
        },
        async moveNotice({ commit }, {feed_from_id, feed_to_id, notice_id, to_feeds}) {
            try {
                const req = await api.put(`/feeds/${feed_from_id}/notices/${notice_id}/move/${feed_to_id}`, {})
                commit('MOVE_NOTICE', {feed_from_id, feed_to_id, notice_id, to_feeds: req.data.data}) 
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось переместить заметку')
                throw e
            }
        },           
        async delNotice({ commit }, {feed_id, notice_id}) {
            try {
                const req = await api.delete(`/feeds/${feed_id}/notices/${notice_id}`)
                commit('UPD_FEED',{_id:feed_id, notices: req.data.data})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось удалить заметку')
                throw e
            }
        },
        async addNoticePush({ commit }, {feed_id, notice_id, data}) {
            try {
                // const _data = {...data}
                const req = await api.post(`/feeds/${feed_id}/notices/${notice_id}/pushes`, {data: JSON.stringify(data)})
                commit('SET_NOTICE_PUSHES', {feed_id, notice_id, pushes:req.data.data})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось добавить уведомление для заметки')
                throw e
            } 
        },          
        async editNoticePush({ commit }, {feed_id, notice_id, push_id, data}) {
            try {
                await api.put(`/feeds/${feed_id}/notices/${notice_id}/pushes/${push_id}`, { attr: data.key, value: JSON.stringify(data.value) })
                commit('EDIT_NOTICE_PUSH', {feed_id, notice_id, push_id, data})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось отредактировать уведомление для заметки')
                throw e
            } 
        },  
        async delNoticePush({ commit }, {feed_id, notice_id, push_id}) {
            try {
                const req = await api.delete(`/feeds/${feed_id}/notices/${notice_id}/pushes/${push_id}`)
                commit('SET_NOTICE_PUSHES',{_id:feed_id, notice_id, pushes: req.data.data})
                return true
            }
            catch (e) {
                commit('SET_ERROR', 'Не удалось удалить уведомление для заметки')
                throw e
            }
        },                
    }
}